import { useTranslation } from '@/utils/hook'
import { libreBaskerville } from '@/fonts'
import { HomeLink } from './presentation'
import styles from './home.module.css'

export function Cta(): JSX.Element {
  const t = useTranslation()
  return (
    <section
      className={`${styles.section} ${styles.cta}`}
      aria-labelledby="home-cta-title"
    >
      <div className={styles.container}>
        <div className={`${styles.heading} ${styles.center}`}>
          <h2
            id="home-cta-title"
            className={`${styles.title} ${libreBaskerville.className}`}
          >
            {t('product.ctaHeading')}
          </h2>
          <p className={styles.description}>{t('product.ctaSubheading')}</p>
          <HomeLink href="https://my.heyform.net/sign-up" button>
            {t('common.tryFree')}
          </HomeLink>
        </div>
      </div>
    </section>
  )
}
